import React from "react";
import { useNavigate } from "react-router-dom";

import "../../styles/components/AiAgentsCases.css";

import Reveal from "../../components/Reveal";

import arrowCircle from "../../img/hero/arrow-circle-2.png";
import cloudsImage from "../../img/cases/case-clouds.webp";

/* CASE IMAGES */
import relatioPhone from "../../img/cases/relatio-phone.webp";
import drslPhone from "../../img/cases/drsl-phone.webp";
import chatshopPhone from "../../img/cases/chatshop-phone.webp";
import futuraTablet from "../../img/cases/futura-tablet.webp";

/* LOGOS */
import relatioLogo from "../../img/cases/relatio-logo.png";
import drslLogo from "../../img/cases/drsl-logo.png";
import chatshopLogo from "../../img/cases/chatshop-logo.png";
import futuraLogo from "../../img/cases/futura-logo.png";

const cases = [
  {
    category: "Relationship",
    title: "AI-Powered Relationship Coaching with Deep Personalization",
    image: relatioPhone,
    logo: relatioLogo,
    slug: "relatio",
    deviceClass: "aac-card__device--relatio",
  },
  {
    category: "AI stylist",
    title: "AI-Powered Virtual Try-On with Realistic Garment Rendering",
    image: drslPhone,
    logo: drslLogo,
    slug: "drsl",
    deviceClass: "aac-card__device--drsl",
  },
  {
    category: "AI E-commerce",
    title: "Conversational AI Storefront Built to Convert",
    image: chatshopPhone,
    logo: chatshopLogo,
    slug: "chatshop",
    deviceClass: "aac-card__device--chatshop",
  },
  {
    category: "Marketing",
    title: "AI-Powered Competitive Analysis Platform for Marketing Teams",
    image: futuraTablet,
    logo: futuraLogo,
    slug: "futura",
    deviceClass: "aac-card__device--futura",
  },
];

function CaseCard({ item, index, navigate }) {
  const handleOpenCase = () => {
    navigate(`/cases/${item.slug}`);
  };

  return (
    <article
      className={`aac-card ${
        index % 2 === 0
          ? "aac-card--from-left"
          : "aac-card--from-right"
      }`}
      onClick={handleOpenCase}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          handleOpenCase();
        }
      }}
    >
      <span className="aac-card__tag">{item.category}</span>

      <img className="aac-card__logo" src={item.logo} alt="" />

      <h3 className="aac-card__title">{item.title}</h3>

      <img
        className={`aac-card__device ${item.deviceClass}`}
        src={item.image}
        alt=""
        aria-hidden="true"
      />

      <img
        className="aac-card__clouds"
        src={cloudsImage}
        alt=""
        aria-hidden="true"
      />

      <button className="aac-card__button" type="button">
        <span>View all case</span>
        <img src={arrowCircle} alt="" aria-hidden="true" />
      </button>
    </article>
  );
}
export default function AiAgentsCases() {
  const navigate = useNavigate();

  return (
    <section className="aac">
      <h2 className="aac__title">AI agents</h2>

      <div className="aac__grid">

        {/* ПЕРШІ 2 КАРТКИ - одразу анімуються */}
        <div className="aac-row-reveal aac-row-reveal--instant">
          {cases.slice(0, 2).map((item, index) => (
            <CaseCard
              key={item.slug}
              item={item}
              index={index}
              navigate={navigate}
            />
          ))}
        </div>

        {/* ДРУГІ 2 КАРТКИ - через скрол */}
        <Reveal
          as="div"
          variant="fade"
          threshold={0.25}
          rootMargin="0px 0px -100px 0px"
          className="aac-row-reveal"
        >
          {cases.slice(2, 4).map((item, index) => (
            <CaseCard
              key={item.slug}
              item={item}
              index={index}
              navigate={navigate}
            />
          ))}
        </Reveal>

      </div>
    </section>
  );
}
